import { IconErrorOutlined, IconEventCategoryAlert } from "@suse-o11y/icons";
import React, { useMemo } from "react";

import type { MessageLevel, MonitorError } from "../../common/openapi";
import { Api } from "../../common/openapi";
import { Table } from "../react/table/Table";
import type { ColumnsType } from "../react/table/TableTypes";
import { TruncateMultiline } from "../react/truncate-multiline";

interface IssuesTabContentProps {
	errors: Array<MonitorError>;
	level: MessageLevel;
}

export const IssuesTabContent: React.FC<IssuesTabContentProps> = ({ errors, level }) => {
	const columns: ColumnsType<MonitorError> = useMemo(
		() => [
			{
				title: `${Api.MessageLevel.ERROR === level ? "Error" : "Warning"} message`,
				dataIndex: "error",
				filterMode: "search",
				render: (_: any, { error }: MonitorError) => (
					<div className="flex items-start gap-3">
						<div className="flex">
							{level === Api.MessageLevel.ERROR && <IconErrorOutlined className="text-red-500 text-xl" />}
							{level === Api.MessageLevel.WARN && <IconEventCategoryAlert className="text-orange-500 text-xl" />}
						</div>
						<TruncateMultiline lineClamp={3}>{error}</TruncateMultiline>
					</div>
				),
			},
			{
				title: "Occurrences",
				dataIndex: "count",
				sorter: (a: MonitorError, b: MonitorError) => a.count - b.count,
				defaultSortOrder: "descend",
				width: 180,
				className: "align-right",
			},
		],
		[level],
	);

	return <Table columns={columns} data={errors} dimHeaderAndBorders pagination={false} sticky withHover />;
};
